import { Placeholder as BootstrapPlaceholder } from 'react-bootstrap';

function Placeholder({ready, children, ...props}) {
  if(ready == undefined) {
    return <BootstrapPlaceholder {...props} />
  } else {
    return children
  }
}

export default Placeholder
